// src/hooks/useTeamMembers.js
import { useState, useEffect, useCallback } from 'react';
import apiService from '../services/api';
import toast from 'react-hot-toast';

const DEPT_COLORS = [
  '#d1688a', '#5b8dd9', '#3db389', '#d16060',
  '#9b7fd4', '#e8943a', '#0891b2', '#65a30d',
];

function normalizeEmployee(user, idx) {
  const firstName = user.firstName ?? '';
  const lastName  = user.lastName  ?? '';
  const fullName  = (firstName || lastName)
    ? `${firstName} ${lastName}`.trim()
    : (user.name ?? user.email ?? '');

  return {
    ...user,
    id:              user.id,
    name:            fullName,
    firstName,
    lastName,
    email:           user.email           ?? '',
    phone:           user.phone           ?? null,
    position:        user.position        ?? null,
    profileImageUrl: user.profileImageUrl ?? null,
    dept:            user.department      ?? user.dept ?? '',
    role:            user.position        ?? user.role ?? 'Member',
    balance:         user.leaveBalance    ?? user.annualLeaveBalance ?? 25,
    used:            user.leaveUsed       ?? user.annualLeaveUsed    ?? 0,
    pending:         user.leavePending    ?? user.pendingLeave       ?? 0,
    color:           DEPT_COLORS[idx % DEPT_COLORS.length],
  };
}

export function useTeamMembers() {
  const [employees, setEmployees] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState(null);

  const fetchMembers = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await apiService.getCompanyUsers();

      // ── Matches exact unwrapping pattern from your Settings.jsx ──
      // res?.data?.users || res?.users || res?.data || []
      const raw = res?.data?.users || res?.users || res?.data || [];
      const list = Array.isArray(raw) ? raw : [];

      setEmployees(list.map((u, i) => normalizeEmployee(u, i)));
    } catch (err) {
      const msg = err?.response?.data?.message ?? 'Failed to load members.';
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMembers(); }, [fetchMembers]);

  return { employees, loading, error, refetch: fetchMembers };
}